import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";
import { getISODate, isoDateToString } from "../../util/format-date";

export default function DatePair({
  label,
  date,
  format = "MM/dd/yyyy",
  link,
  onClick,
  edit,
  loading,
  classes,
  inputOptions,
}) {
  const { navigate } = useContext(UtilityContext);

  const clickHandler = (e) => {
    if (onClick) onClick(date);
    if (link) navigate(link, e);
  };

  const classNames = () => {
    let classes = "";
    if (link || onClick) classes += "cursor-pointer hover:opacity-70";
    return classes;
  };

  const onChange = (e) => {
    const dateValue = e.target.value;
    const isoDate = getISODate(dateValue, "00:00:00");
    document.getElementById("datePairDate").value = isoDate;
  };

  if (!inputOptions) inputOptions = { id: label.toLowerCase() };
  else if (!inputOptions?.id && !inputOptions?.name)
    inputOptions.id = label.toLowerCase();
  else if (!inputOptions?.name) inputOptions.name = inputOptions.id;
  else if (!inputOptions?.id) inputOptions.id = inputOptions.name;

  if (loading)
    return (
      <div className="grid w-3/4 gap-1">
        <div className="w-1/3 h-4 rounded animate-pulse bg-stone-700"></div>
        <div className="h-6 rounded animate-pulse bg-stone-600"></div>
      </div>
    );

  return (
    <div onClick={clickHandler} className={classNames()}>
      <p className="text-stone-400">{label}:</p>
      {!edit && (
        <p className={classes || "text-stone-200"}>
          {isoDateToString(date, format)}
        </p>
      )}
      <input
        className="hidden"
        defaultValue={date}
        autoComplete="off"
        {...inputOptions}
        type="text"
      />
      {edit && (
        <input
          className="w-full form-input"
          defaultValue={date && isoDateToString(date, "yyyy-MM-dd")}
          autoComplete="off"
          type="date"
          id="datePairDate"
          onChange={onChange}
        />
      )}
    </div>
  );
}
